// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"TestPage_wrap_div__VCtJD","back_img":"TestPage_back_img__iEPmT","page_break":"TestPage_page_break__2iLGu"};